import React from "react";
import "./tech.scss";
function Tech() {
  return (
    <div className="Technologies" id="technologies">
      <h1>My Tech Stack</h1>
      <div className="Tech">
        <div className="TechItem">
          <img src="assets/javascript.png" alt="" />
          <h3>Javascript</h3>
        </div>

        <div className="TechItem">
          <img src="assets/firebase.png" alt="" />
          <h3>Firebase</h3>
        </div>
        <div className="TechItem">
          <img src="assets/react.png" alt="" />
          <h3>ReactJS</h3>
        </div>
        <div className="TechItem">
          <img src="assets/mongodb.png" alt="" />
          <h3>MongoDB</h3>
        </div>
        <div className="TechItem">
          <img src="assets/nodejs.png" alt="" />
          <h3>NodeJS</h3>
        </div>
        <div className="TechItem">
          <img src="assets/nestjs.png" alt="" />
          <h3>NestJS</h3>
        </div>
      </div>
    </div>
  );
}

export default Tech;
